import { render } from "./BarcodeLinkScan.vue?vue&type=template&id=04b8cc50&scoped=true"
import script from "./BarcodeLinkScan.vue?vue&type=script&lang=ts"
export * from "./BarcodeLinkScan.vue?vue&type=script&lang=ts"

import "./BarcodeLinkScan.vue?vue&type=style&index=0&id=04b8cc50&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-04b8cc50"

export default script